import React from 'react';
import ToastAction from './ToastAction';
import ToastCloseButton from './ToastCloseButton';
import ToastContainer from './ToastContainer';
import ToastIcon from './ToastIcon';
import ToastMessage from './ToastMessage';
const Toast = ({ variant, position, message, action, isCloseable, onClose, backgroundColor, actionColor, }) => (React.createElement(ToastContainer, { backgroundColor: backgroundColor, position: position },
    variant && React.createElement(ToastIcon, { variant: variant }),
    message && React.createElement(ToastMessage, null, message),
    action && React.createElement(ToastAction, { actionColor: actionColor }, action),
    isCloseable && React.createElement(ToastCloseButton, { onClick: onClose })));
export default Toast;
